var React = require('react');

function IconWordO (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M881.3 341.1L610.1 66.5c-1.9-1.9-4.4-3-7.1-3H143.4l-.4 884.2c0 5.5 4.5 10 10 10h721.4c5.5 0 10-4.5 10-10l-.2-599.6c0-2.6-1-5.1-2.9-7zM571.7 139.3L812 379.6l.2 502.3H216.4l.5-742.6","key":0}),React.createElement("path",{"d":"M297.5 654.8h440.1c5.5 0 10 4.5 10 10v73.5c0 5.5-4.5 10-10 10H297.5c-5.5 0-10-4.5-10-10v-73.5c0-5.5 4.5-10 10-10zM297.5 467.7h440.1c5.5 0 10 4.5 10 10v73.5c0 5.5-4.5 10-10 10H297.5c-5.5 0-10-4.5-10-10v-73.5c0-5.5 4.5-10 10-10zM540.7 182.8l218.1 216.9H540.7V182.8z","key":1})]);
}

IconWordO.displayName = "IconWordO";

IconWordO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconWordO;

IconWordO.default = IconWordO;
